import {CSSTransition} from "react-transition-group";

export default function ActionSheet(props) {
  const {
    children,
    visible,
    title,
    onClose
  } = props;
  
  
  return (
    <CSSTransition
      in={visible}
      timeout={300}
      unmountOnExit={true}
      classNames="slideBottomIn">
      <div className="rounded-t-[12px] z-50 bg-white fixed container"
           style={{
             left: 0,
             bottom: 0,
             zIndex:999,
           }}>
        {
          title &&
          <div className="flex justify-between py-[10px] px-[20px]">
            <i className="iconfont icon-delete text-white"></i>
            <p className="text-[16px]">{title}</p>
            <i onClick={() => onClose(false)} className="iconfont icon-delete text-[#999]"></i>
          </div>
        }
        <div style={{
          minHeight: 200,
          maxHeight: '78vh',
          overflowY: 'scroll'
        }}>
          {children}
        </div>
      </div>
    </CSSTransition>
  );
}
